module.exports = __webpack_public_path__ + "static/media/permission-denied-lock.74bba15d.svg";